import { render, staticRenderFns } from "./B2BOrderFormBox.vue?vue&type=template&id=716c5ffd&scoped=true"
import script from "./B2BOrderFormBox.vue?vue&type=script&lang=js"
export * from "./B2BOrderFormBox.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./B2BOrderFormBox.vue?vue&type=style&index=1&id=716c5ffd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "716c5ffd",
  null
  
)

export default component.exports